import { useEffect, useRef } from "react";
import { Carousel } from "react-bootstrap";

const HeroImage = ({ item, isFirst, onClick, onFirstLoad }) => {
  const imgRef = useRef(null);
  const notifiedRef = useRef(false);

  const notifyReady = () => {
    if (!isFirst || notifiedRef.current) return;
    notifiedRef.current = true;
    onFirstLoad?.();
  };

  useEffect(() => {
    if (isFirst && imgRef.current?.complete) {
      notifyReady();
    }
  }, [isFirst]);

  return (
    <img
      ref={imgRef}
      className="d-block w-100 img-fluid cursor-pointer hero-slider__img"
      src={item.slider}
      alt="Montironi Ford"
      onClick={onClick}
      onLoad={notifyReady}
      fetchPriority={isFirst ? "high" : "auto"}
      loading={isFirst ? "eager" : "lazy"}
      decoding="async"
      sizes="100vw"
    />
  );
};

const HeroCarousel = ({ slides, onSlideClick, onFirstSlideLoad }) => {
  if (!slides.length) return null;

  if (slides.length === 1) {
    return (
      <HeroImage item={slides[0]} isFirst onClick={onSlideClick} onFirstLoad={onFirstSlideLoad} />
    );
  }

  return (
    <Carousel>
      {slides.map((item, index) => (
        <Carousel.Item key={index}>
          <HeroImage
            item={item}
            isFirst={index === 0}
            onClick={onSlideClick}
            onFirstLoad={onFirstSlideLoad}
          />
        </Carousel.Item>
      ))}
    </Carousel>
  );
};

export default HeroCarousel;
